import { render, staticRenderFns } from "./QuizSlideContent.vue?vue&type=template&id=0f820f84&scoped=true&"
import script from "./QuizSlideContent.vue?vue&type=script&lang=js&"
export * from "./QuizSlideContent.vue?vue&type=script&lang=js&"
import style0 from "./QuizSlideContent.vue?vue&type=style&index=0&id=0f820f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f820f84",
  null
  
)

export default component.exports